import React from "react";
import { useNavigate } from 'react-router-dom';
import Popup from "../../../components/Popups/Popup";
import CreateLicenseView from "../../Licenses/Components/CreateLicense";

interface PopupProps {
    show: boolean
    onHide: () => void
}

const CreateLicensePopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const navigate = useNavigate();

    function onLicenseCreated(licenseId: number) {
        if (licenseId) {
            navigate('/plm/Licenses/Details/' + licenseId);
        } else {
            if (onHide)
                onHide();
        }
    }

    return (
        <Popup show={show} onHide={onHide} size={'xl'} title={'Create new license'} >
            <Popup.Body>
                <CreateLicenseView onLicenseCreated={onLicenseCreated} />
            </Popup.Body>
        </Popup>
    );
}
export default CreateLicensePopup;